import { useEffect, useState } from 'react';

import { readStorage, Storage, writeStorage } from './storage';

export const usePersistentState = <T>(
  key: string,
  initialState: T,
  storage: Storage = 'local'
) => {
  const [state, setState] = useState<T>(
    readStorage.bind(null, key, initialState, storage) as () => T
  );

  const setPersistedState = (value: T | ((value: T) => T)) => {
    if (typeof value === 'function') {
      setState((prev) => {
        const newValue = (value as (value: T) => T)(prev);
        writeStorage(key, newValue, storage);
        return newValue;
      });
    } else {
      writeStorage(key, value, storage);
      setState(value);
    }
  };

  useEffect(() => {
    setState(readStorage(key, initialState, storage));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return [state, setPersistedState] as const;
};
